export enum ApplicationFormSchemaGraphicsFields {
  LOGO = 'logo',
  ICON = 'icon',
}
